import { AppsProvider } from './types';

export const SUPPORTED_APPS_PROVIDERS: AppsProvider[] = ['youtube', 'canva'];
